import { Quill } from 'react-quill';

const { Attributor, Scope } = Quill.import('parchment');

export const LetterSpacingWhitelist = ['1px', '2px', '3px', '4px'];

const config = {
  scope: Scope.INLINE,
  whitelist: LetterSpacingWhitelist,
};

export const LetterSpacingClass = new Attributor.Class(
  'letter-spacing',
  'span',
  config,
);

export const LetterSpacingStyle = new Attributor.Style(
  'letter-spacing',
  'letter-spacing',
  config,
);
